export const translations = {
  en: {
    nav: {
      track: "Track",
      fleet: "Fleet",
      pricing: "Pricing",
      experience: "Experience",
      gallery: "Gallery",
      faq: "FAQ",
      contact: "Contact",
      events: "Events",
      advertise: "Advertise",
      book: "Book Now",
    },
    closure: {
      eyebrow: "Important notice",
      title: "The track is closed indefinitely",
      reason: "Karting Track Krasna Polyana has been closed since July 26 for an indefinite period.",
      compensation: "As soon as we have information about when the track will reopen, everyone who booked a session during the closure period will be notified.",
      social: "The reopening will also be announced on the track's Instagram and Facebook pages:",
      confirmation: "I have read and understood this notice.",
      continue: "Continue to the website",
      bar: "The track has been closed since July 26 for an indefinite period",
      details: "More information",
      openDetails: "Open temporary closure information",
      close: "Close",
      back: "Back to the website",
    },    hero: {
      overline: "Krasna Polyana — Sofia, Bulgaria",
      title1: "Race",
      title2: "The",
      title3: "Limit",
      subtitle: "An outdoor karting circuit engineered for raw speed, real adrenaline, and unforgettable racing memories.",
      cta_primary: "Reserve a session",
      cta_secondary: "Watch the track",
      scroll: "Scroll to explore",
    },
    marquee: "960M LENGTH  ·  16 TURNS  ·  70 KM/H  ·  OUTDOOR CIRCUIT  ·  14 KARTS MAX  ·  364 DAYS / YEAR  ·  ",
    track: {
      overline: "The Circuit",
      title: "A track built for racing.",
      desc: "960 meters of pure asphalt. 16 technical turns. Engineered for both adrenaline and consistency — designed so every lap teaches you something new.",
      stats: [
        { label: "Track width", value: "12", unit: "m" },
        { label: "Lap record", value: "1.02", unit: "min." },
        { label: "Night lights", value: "16", unit: "lamps" },
        { label: "Direction", value: "CW", unit: "" },
      ],
      leaderboard_title: "Top Lap Times",
      leaderboard_sub: "Live from RaceFacer · Adult Karts",
    },
    fleet: {
      overline: "The Fleet",
      title: "Built. Tuned. Maintained.",
      desc: "Three categories. One obsession with performance. Each kart is serviced daily and equipped with remote speed control for safety without compromise.",
      adult: {
        name: "Adult Kart",
        spec: "270cc · 9 hp",
        top: "70 km/h",
        meta: "16+ years · 145 cm+",
        count: "14 units",
      },
      kids: {
        name: "Kids Kart",
        spec: "160cc · 4.8 hp",
        top: "45 km/h",
        meta: "7–16 years · 135–170 cm",
        count: "12 units",
      },
      double: {
        name: "Double Kart",
        spec: "270cc · 9 hp",
        top: "55 km/h",
        meta: "Adult + Child (4–12, 100+ cm)",
        count: "3 units",
      },
    },
    pricing: {
      overline: "Pricing",
      title: "Pick your pace.",
      desc: "Sessions of 10 or 15 minutes. Helmets included. No hidden fees. Race when you want, how you want.",
      duration_10: "10 minutes",
      duration_15: "15 minutes",
      from: "from",
      reserve: "Reserve",
      categories: {
        kids: "Kids",
        double: "Double",
        adult: "Adult",
      },
      extras_title: "Add-ons",
      extras: [
        { name: "Onboard 4K Video", price: "6.80 BGN", desc: "Helmet-mounted action camera. Your race, your replay." },
        { name: "Balaclava", price: "2.93 BGN", desc: "Required hygiene mask under the helmet. Bring your own or grab one." },
      ],
    },
    experience: {
      overline: "Beyond the Track",
      title: "Race. Eat. Repeat.",
      pitstop_title: "Pitstop Burgers",
      pitstop_desc: "Fresh, smashed, juicy. Fuel up between sessions with our on-site burger spot. Cold drinks. Hot fries. Zero compromise.",
      pitstop_cta: "View Menu",
      vouchers_title: "Gift the speed.",
      vouchers_desc: "Product, value and session-pack vouchers. Valid 180 days. The perfect motorsport gift.",
      vouchers_cta: "Browse vouchers",
    },
    booking: {
      overline: "Reserve Your Slot",
      title: "Request a session.",
      desc: "Drop your details — we'll confirm availability by phone or email within the hour. Online booking integration coming soon.",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      type: "Session type",
      drivers: "Drivers",
      date: "Preferred date",
      message: "Additional details",
      submit: "Send request",
      submitting: "Sending...",
      success: "Request received. We'll be in touch shortly.",
      error: "Something went wrong. Please try again.",
      types: {
        adult: "Adult Kart",
        kids: "Kids Kart",
        double: "Double Kart",
        event: "Private Event / Group",
      },
    },
    faq: {
      overline: "FAQ",
      title: "Everything you'll wonder.",
      categories: [
        {
          name: "General",
          items: [
            { q: "Is there parking available?", a: "Yes — ample free parking on-site." },
            { q: "How long is the track?", a: "960 meters with 16 turns." },
            { q: "Is the track open in winter?", a: "Open 7 days/week, 364 days/year (closed only on Christmas). Racing only if the track is dry and above 0°C." },
            { q: "Can I bring my own GoPro?", a: "Yes, helmet-mounted only. We also rent 4K helmet cameras for 6.80 BGN." },
          ],
        },
        {
          name: "Reservations",
          items: [
            { q: "Do I need to book in advance?", a: "Not mandatory but strongly recommended. Without a reservation, we can't guarantee a slot." },
            { q: "How can I cancel or change a booking?", a: "At least 24 hours in advance to receive a voucher. Force majeure (wet track) = full refund." },
            { q: "What if I'm late?", a: "Arrive at least 40 minutes before your session. Late = lost reservation." },
          ],
        },
        {
          name: "Karting",
          items: [
            { q: "Do I need a license?", a: "No — no driver's license required." },
            { q: "Is there a weight limit?", a: "Yes, maximum driver weight is 130 kg." },
            { q: "Are there age/height requirements?", a: "Kids karts: 7–16 yrs, 135–170 cm. Adult karts: 16+, over 145 cm. Double karts: adult (18+) + child (4–12, 100+ cm)." },
            { q: "Do I need to sign a waiver?", a: "Yes, at the front desk before driving. Minors under 16 need a parent/guardian present." },
          ],
        },
        {
          name: "Pricing & Loyalty",
          items: [
            { q: "Do you offer discounts for regulars?", a: "Yes, based on total km driven: 250km = 5%, 500km = 10%, 1000km = 15%, 2000km = 20%." },
            { q: "Payment methods?", a: "Cards, cash, contactless. Invoices on request." },
          ],
        },
      ],
    },
    contact: {
      overline: "Find Us",
      title: "Krasna Polyana, Sofia.",
      address: "Sofia, Krasna Polyana district",
      phone: "+359 88 8860950",
      email: "kartingsport@abv.bg",
      hours_title: "Working Hours",
      hours: [
        { day: "Mon — Fri", time: "13:00 — 22:00" },
        { day: "Sat — Sun", time: "11:00 — 22:00" },
      ],
      hours_note: "Hours vary by season. Always check before visiting. Closed only on Christmas.",
    },
    events: {
      overline: "Private Events",
      title: "Throw a race-day to remember.",
      desc: "Birthdays, corporate offsites, team-buildings, bachelor parties. The track is yours — we handle everything else.",
      types_title: "What kind of event?",
      types: {
        birthday: "Birthday",
        corporate: "Corporate",
        team_building: "Team Building",
        bachelor: "Bachelor Party",
        other: "Other",
      },
      bullets: [
        { t: "Up to 14 drivers / heat", d: "Run elimination rounds, finals, podium ceremonies." },
        { t: "Private track time", d: "Book the whole circuit for your group — no strangers, no waiting." },
        { t: "Catering & burgers", d: "Pitstop Burgers on-site. Custom menus for groups of 10+." },
        { t: "Trophies & prizes", d: "Optional custom trophies, medals, and championship banners." },
      ],
      form_title: "Send your event request.",
      form_desc: "Tell us what you're planning — we'll come back with a tailored quote within one working day.",
      name: "Contact name",
      email: "Email",
      phone: "Phone",
      event_type: "Event type",
      guests: "Number of guests",
      date: "Preferred date",
      time: "Preferred time",
      addons_label: "Optional extras",
      addons: {
        catering: "Catering / Burgers",
        trophies: "Trophies & medals",
        video: "Race video / photo",
        drinks: "Drinks package",
        decor: "Decoration",
      },
      message: "Anything else?",
      submit: "Request my event",
      submitting: "Sending...",
      success: "Got it. We'll get back to you within 1 working day.",
      error: "Something went wrong. Please try again.",
      reset: "New request",
      upcoming_title: "Upcoming events",
      upcoming_sub: "Mark your calendar — these are open to public sign-up.",
      past_title: "Past events",
      past_sub: "A taste of what we've put on. Browse the highlights.",
      cta_join: "Join",
      cta_recap: "View recap",
    },
    advertise: {
      overline: "Advertise with us",
      title: "Put your brand on the track.",
      desc: "Real eyeballs, real engagement. Karting fans see your brand in motion — on the track, on our karts, on our screens, and across our channels.",
      intro_title: "Choose a spot.",
      intro_desc: "Pick the placement that fits your brand. Click any spot to start a conversation — we'll come back with rates and availability.",
      contact_note: "Want a custom package? Talk to us directly →",
      contact_cta: "Contact our team",
      spots_title: "Available placements",
      cta_spot: "Reserve this spot",
      spots: [
        {
          id: "trackside-banner",
          name: "Trackside Banner",
          spec: "3 x 1 m · vinyl · 6+ months",
          desc: "Full-color banner at the most-photographed corner. Visible from the spectator zone and on every race video.",
        },
        {
          id: "kart-livery",
          name: "Kart Livery",
          spec: "Side pod + nose · adult karts",
          desc: "Your logo on our adult fleet. Photographed by every customer, shared on social, lasting visibility.",
        },
        {
          id: "podium-backdrop",
          name: "Podium Backdrop",
          spec: "4 x 2.5 m · printed wall",
          desc: "The backdrop behind every podium ceremony — every champion's selfie has your logo.",
        },
        {
          id: "helmet-cam-overlay",
          name: "Helmet-cam Video Overlay",
          spec: "Watermark · all rented cameras",
          desc: "Branded overlay on every helmet-cam clip our customers take home. Goes straight to social media.",
        },
        {
          id: "social-takeover",
          name: "Social Media Takeover",
          spec: "Instagram + Facebook · 30 days",
          desc: "Featured partner across our owned channels: posts, stories, reel collabs, and tagged race highlights.",
        },
        {
          id: "custom",
          name: "Custom Sponsorship",
          spec: "Tailored package",
          desc: "Event title sponsor, championship naming rights, branded race weekends — let's build something unique.",
        },
      ],
    },
    footer: {
      tagline: "Outdoor Karting · Sofia · Bulgaria",
      rights: "All rights reserved.",
      built: "Built for speed.",
    },
    gallery: {
      overline: "Gallery",
      title: "On the asphalt.",
      desc: "Moments captured between corner entry, apex and exit. Tap any frame for full view.",
      close: "Close",
    },
    pages: {
      home: "Home",
      track_desc: "960 meters of asphalt. 16 turns. A circuit built to teach you something new every lap.",
      fleet_desc: "Three kart families. Each machine serviced daily. Each session governed by remote speed control.",
      pricing_desc: "Honest pricing. Helmets included. Pay for the laps, never for the paperwork.",
      experience_desc: "Race. Eat. Win something to bring home.",
      faq_desc: "Everything worth asking before you strap in.",
      contact_desc: "Find us in Krasna Polyana, Sofia. Open 364 days a year.",
      events_desc: "Birthdays, corporate, team-building. Book the whole track for your group.",
      advertise_desc: "Put your brand in front of motorsport fans — trackside, on karts, on screens.",
      booking_desc: "Send a request — we'll confirm within the hour during working hours.",
      gallery_meta: "26 frames",
    },
  },
  bg: {
    nav: {
      track: "Пистата",
      fleet: "Картове",
      pricing: "Цени",
      experience: "Преживяване",
      gallery: "Галерия",
      faq: "Въпроси",
      contact: "Контакти",
      events: "Събития",
      advertise: "Реклама",
      book: "Резервирай",
    },
    closure: {
      eyebrow: "Важно съобщение",
      title: "Пистата е затворена за неопределен период",
      reason: "Картинг писта „Красна поляна“ е затворена от 26 юли за неопределен период.",
      compensation: "Веднага щом имаме информация кога пистата ще отвори отново, всички, които са запазили час през периода, в който тя е била затворена, ще бъдат уведомени.",
      social: "Отварянето ще бъде обявено и в социалните мрежи на пистата — Instagram и Facebook:",
      confirmation: "Прочетох и разбрах това съобщение.",
      continue: "Продължи към сайта",
      bar: "Пистата е затворена от 26 юли за неопределен период",
      details: "Повече информация",
      openDetails: "Отвори информацията за временното затваряне",
      close: "Затвори",
      back: "Обратно към сайта",
    },    hero: {
      overline: "Красна поляна — София, България",
      title1: "Прескочи",
      title2: "Своите",
      title3: "Граници",
      subtitle: "Открита картинг писта, създадена за чиста скорост, истински адреналин и незабравими състезателни моменти.",
      cta_primary: "Резервирай сесия",
      cta_secondary: "Виж пистата",
      scroll: "Скролни надолу",
    },
    marquee: "960М ДЪЛЖИНА  ·  16 ЗАВОЯ  ·  70 КМ/Ч  ·  ОТКРИТА ПИСТА  ·  МАКС. 14 КАРТА  ·  364 ДНИ / ГОДИНА  ·  ",
    track: {
      overline: "Пистата",
      title: "Писта, създадена за състезания.",
      desc: "960 метра чист асфалт. 16 технически завоя. Проектирана както за адреналин, така и за постоянство — всяка обиколка ще те научи на нещо ново.",
      stats: [
        { label: "Ширина на пистата", value: "12", unit: "м" },
        { label: "Рекорд", value: "1.02", unit: "мин." },
        { label: "Нощно осветление", value: "16", unit: "лампи" },
        { label: "Посока", value: "CW", unit: "" },
      ],
      leaderboard_title: "Най-добри обиколки",
      leaderboard_sub: "На живо от RaceFacer · Картове за възрастни",
    },
    fleet: {
      overline: "Картовете",
      title: "Произведени. Настроени. Поддържани.",
      desc: "Три категории. Една обсесия — производителност. Всеки карт се обслужва ежедневно и има дистанционен контрол на скоростта.",
      adult: {
        name: "Карт за възрастни",
        spec: "270cc · 9 к.с.",
        top: "70 км/ч",
        meta: "16+ години · 145 см+",
        count: "14 броя",
      },
      kids: {
        name: "Детски карт",
        spec: "160cc · 4.8 к.с.",
        top: "45 км/ч",
        meta: "7–16 години · 135–170 см",
        count: "12 броя",
      },
      double: {
        name: "Двоен карт",
        spec: "270cc · 9 к.с.",
        top: "55 км/ч",
        meta: "Възрастен + дете (4–12, 100+ см)",
        count: "3 броя",
      },
    },
    pricing: {
      overline: "Цени",
      title: "Избери своето темпо.",
      desc: "Сесии от 10 или 15 минути. Каските са включени. Без скрити такси. Карай, когато искаш, както искаш.",
      duration_10: "10 минути",
      duration_15: "15 минути",
      from: "от",
      reserve: "Резервирай",
      categories: {
        kids: "Деца",
        double: "Двоен",
        adult: "Възрастни",
      },
      extras_title: "Допълнителни услуги",
      extras: [
        { name: "Бордно 4K видео", price: "€4", desc: "Камера, монтирана на каската. Твоето състезание, твоят клип." },
        { name: "Балаклава", price: "€2", desc: "Задължителна хигиенна маска под каската. Донеси своя или вземи на място." },
      ],
    },
    experience: {
      overline: "Отвъд пистата",
      title: "Карай. Хапни. Повтори.",
      pitstop_title: "Pitstop Burgers",
      pitstop_desc: "Свежи, пресовани, сочни. Зареди се между сесиите в нашия бургер ъгъл. Студени напитки. Горещи пържени. Без компромиси.",
      pitstop_cta: "Виж менюто",
      vouchers_title: "Подари скоростта.",
      vouchers_desc: "Продуктови, стойностни и пакетни ваучери. Валидни 180 дни. Перфектният моторспорт подарък.",
      vouchers_cta: "Разгледай ваучерите",
    },
    booking: {
      overline: "Резервирай слот",
      title: "Заяви сесия.",
      desc: "Остави данните си — ще потвърдим наличността по телефон или имейл до един час. Онлайн резервацията идва скоро.",
      name: "Име и фамилия",
      email: "Имейл",
      phone: "Телефон",
      type: "Тип сесия",
      drivers: "Брой пилоти",
      date: "Желана дата",
      message: "Допълнителни детайли",
      submit: "Изпрати заявка",
      submitting: "Изпращане...",
      success: "Заявката е получена. Ще се свържем с теб скоро.",
      error: "Нещо се обърка. Опитай отново.",
      types: {
        adult: "Карт за възрастни",
        kids: "Детски карт",
        double: "Двоен карт",
        event: "Частно събитие / Група",
      },
    },
    faq: {
      overline: "Въпроси",
      title: "Всичко, което се питаш.",
      categories: [
        {
          name: "Общи",
          items: [
            { q: "Има ли паркинг?", a: "Да — изобилно безплатно паркиране на място." },
            { q: "Колко е дълга пистата?", a: "960 метра с 16 завоя." },
            { q: "Отворени ли сте през зимата?", a: "Отворено 7 дни/седмица, 364 дни/година (затворено само на Коледа). Каране само при суха писта и над 0°C." },
            { q: "Мога ли да донеса своя GoPro?", a: "Да, само монтирана на каска. Имаме и под наем 4K каскови камери за 6.80 лв." },
          ],
        },
        {
          name: "Резервации",
          items: [
            { q: "Трябва ли да резервирам предварително?", a: "Не е задължително, но силно препоръчително. Без резервация не можем да гарантираме място." },
            { q: "Как мога да отменя или променя резервацията?", a: "Минимум 24 часа предварително — получаваш ваучер. При мокра писта = пълно възстановяване." },
            { q: "Какво ако закъснея?", a: "Идвай поне 40 минути преди сесията. Закъснение = загуба на резервация." },
          ],
        },
        {
          name: "Картинг",
          items: [
            { q: "Нужна ли е книжка?", a: "Не — не се изисква шофьорска книжка." },
            { q: "Има ли лимит на теглото?", a: "Да, максимум 130 кг на пилот." },
            { q: "Какви са възрастовите изисквания?", a: "Детски: 7–16 г., 135–170 см. Възрастни: 16+, над 145 см. Двойни: възрастен (18+) + дете (4–12, 100+ см)." },
            { q: "Трябва ли да подпиша декларация?", a: "Да, на рецепцията преди карането. За непълнолетни под 16 г. — родител/настойник." },
          ],
        },
        {
          name: "Цени и лоялност",
          items: [
            { q: "Имате ли отстъпки за редовни клиенти?", a: "Да, на база общо изминати км: 250км = 5%, 500км = 10%, 1000км = 15%, 2000км = 20%." },
            { q: "Какви методи на плащане приемате?", a: "Карти, кеш, безконтактно. Фактури при заявка." },
          ],
        },
      ],
    },
    contact: {
      overline: "Намери ни",
      title: "Красна поляна, София.",
      address: "София, кв. Красна поляна",
      phone: "+359 88 8860950",
      email: "kartingsport@abv.bg",
      hours_title: "Работно време",
      hours: [
        { day: "Пон — Пет", time: "13:00 — 22:00" },
        { day: "Съб — Нед", time: "11:00 — 22:00" },
      ],
      hours_note: "Часовете варират сезонно. Винаги проверявайте преди посещение. Затворено само на Коледа.",
    },
    events: {
      overline: "Частни събития",
      title: "Организирай незабравимо състезание.",
      desc: "Рождени дни, корпоративни събития, тиймбилдинги, ергенски партита. Пистата е твоя — ние се грижим за всичко останало.",
      types_title: "Какъв вид събитие?",
      types: {
        birthday: "Рожден ден",
        corporate: "Корпоративно",
        team_building: "Тиймбилдинг",
        bachelor: "Ергенско парти",
        other: "Друго",
      },
      bullets: [
        { t: "До 14 пилота / манш", d: "Елиминации, финал, церемония с подиум." },
        { t: "Цялата писта за вас", d: "Резервирай цялата писта само за твоята група — без чужди хора, без чакане." },
        { t: "Кетъринг и бургери", d: "Pitstop Burgers на място. Персонализирани менюта за групи 10+." },
        { t: "Купи и медали", d: "По желание — персонализирани купи, медали и шампионски банери." },
      ],
      form_title: "Изпрати заявка за събитие.",
      form_desc: "Кажи ни какво планираш — ще се върнем с персонална оферта до един работен ден.",
      name: "Контактно лице",
      email: "Имейл",
      phone: "Телефон",
      event_type: "Тип събитие",
      guests: "Брой гости",
      date: "Желана дата",
      time: "Желан час",
      addons_label: "Допълнителни услуги",
      addons: {
        catering: "Кетъринг / Бургери",
        trophies: "Купи и медали",
        video: "Видео / снимки от състезанието",
        drinks: "Пакет напитки",
        decor: "Декорация",
      },
      message: "Нещо допълнително?",
      submit: "Заяви събитие",
      submitting: "Изпращане...",
      success: "Получихме заявката. Ще ти отговорим до 1 работен ден.",
      error: "Нещо се обърка. Опитай отново.",
      reset: "Нова заявка",
      upcoming_title: "Предстоящи събития",
      upcoming_sub: "Запиши си датата — отворени за публично записване.",
      past_title: "Минали събития",
      past_sub: "Поглед към това, което сме организирали.",
      cta_join: "Запиши се",
      cta_recap: "Виж резюме",
    },
    advertise: {
      overline: "Реклама при нас",
      title: "Постави бранда си на пистата.",
      desc: "Истинска видимост, истинско внимание. Феновете на картинга виждат твоя бранд в действие — на пистата, на нашите картове, на екраните и в каналите ни.",
      intro_title: "Избери място.",
      intro_desc: "Избери позицията, която подхожда на бранда ти. Цъкни на което и да е място — ще се върнем с цени и наличност.",
      contact_note: "Искаш персонален пакет? Свържи се директно →",
      contact_cta: "Свържи се с екипа",
      spots_title: "Свободни места",
      cta_spot: "Резервирай това място",
      spots: [
        {
          id: "trackside-banner",
          name: "Банер на пистата",
          spec: "3 x 1 м · винил · 6+ месеца",
          desc: "Цветен банер на най-снимания завой. Видим от зоната за зрители и във всяко състезателно видео.",
        },
        {
          id: "kart-livery",
          name: "Брандиране на карт",
          spec: "Странични панели + нос · карт за възрастни",
          desc: "Логото ти на нашия флот. Снимано от всеки клиент, споделяно в социалните мрежи.",
        },
        {
          id: "podium-backdrop",
          name: "Подиум фон",
          spec: "4 x 2.5 м · печатна стена",
          desc: "Фонът зад всяка церемония на подиума — селфито на всеки победител е с твоето лого.",
        },
        {
          id: "helmet-cam-overlay",
          name: "Видео овърлей",
          spec: "Воден знак · всички наети камери",
          desc: "Брандиран овърлей на всеки клип от каска, който клиентите взимат. Отива право в социалните мрежи.",
        },
        {
          id: "social-takeover",
          name: "Социални мрежи",
          spec: "Instagram + Facebook · 30 дни",
          desc: "Партньор във всичките ни канали: постове, stories, reel колаборации и тагнати моменти от състезания.",
        },
        {
          id: "custom",
          name: "Персонално партньорство",
          spec: "Индивидуален пакет",
          desc: "Заглавен спонсор, право на име на шампионата, брандирани състезателни уикенди — да измислим нещо уникално.",
        },
      ],
    },
    footer: {
      tagline: "Открит картинг · София · България",
      rights: "Всички права запазени.",
      built: "Създадено за скорост.",
    },
    gallery: {
      overline: "Галерия",
      title: "На асфалта.",
      desc: "Моменти, уловени между влизане в завой, апекс и излизане. Натисни всеки кадър за пълен изглед.",
      close: "Затвори",
    },
    pages: {
      home: "Начало",
      track_desc: "960 метра асфалт. 16 завоя. Писта, която ще те научи на нещо ново всяка обиколка.",
      fleet_desc: "Три фамилии картове. Всяка машина обслужвана ежедневно. Всяка сесия с дистанционен контрол.",
      pricing_desc: "Честни цени. Каските включени. Плащаш за обиколките, не за документация.",
      experience_desc: "Карай. Хапни. Спечели нещо за вкъщи.",
      faq_desc: "Всичко важно преди да си сложиш каската.",
      contact_desc: "Намери ни в Красна поляна, София. Отворено 364 дни в годината.",
      events_desc: "Рождени дни, корпоративни, тиймбилдинг. Резервирай цялата писта за групата си.",
      advertise_desc: "Постави бранда си пред феновете на моторспорта — на пистата, на картове, на екраните.",
      booking_desc: "Изпрати заявка — потвърждаваме до час в работно време.",
      gallery_meta: "26 кадъра",
    },
  },
};


